import { defineAsyncComponent as e } from "vue";
import { getI18n as t } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var n = {
	en: {
		articlesBoxApi: {
			createAlreadyExists: "Internal linkbox cannot be created because another internal linkbox with this name already exists",
			updateAlreadyExists: "Internal linkbox cannot be updated because another internal linkbox with this name already exists",
			created: "Internal linkbox created",
			updated: "Internal linkbox updated",
			notFound: "Internal linkbox not found",
			requiredFields: "The internal linkbox cannot be saved because mandatory information is missing."
		},
		articlesBoxList: {
			newButton: "New internal linkbox",
			search: "Search for title, description or ID",
			deleteArticlesBox: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading internal linkbox",
			description: "Description (internal)",
			title: "Title",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createArticlesBox: "Create internal linkbox",
			articleLinksCount: "Number of articles"
		},
		articlesBox: {
			selectorPlaceholder: "Select internal linkbox",
			showImagesCheckboxLabel: "Show as list with images",
			editBox: "Edit list",
			articlesBoxLabel: "Internal linkbox",
			newArticlesBox: "New internal linkbox",
			messageDeleteArticlesBox: "Delete internal linkbox",
			messageDeleteArticlesBoxTitle: "Are you sure you want to delete the internal linkbox?",
			deleteArticlesBox: "Delete",
			messageDeleted: "Internal linkbox deleted",
			errorOnDeleting: "Error deleting the internal linkbox",
			errorFailedLoadedArticlesBoxWithId: "Error loading the internal linkbox",
			description: "Description (internal)",
			contentBlockLabel: "Internal linkbox"
		},
		articlesBoxEdit: {
			title: "Title",
			description: "Description (internal)",
			editArticlesBox: "Edit internal linkbox",
			messageSaved: "New internal linkbox saved",
			linkArticlesButton: "Link articles",
			addLinkButton: "Add link",
			addLink: "Add link",
			linkTitle: "Link title",
			linkUrl: "Link URL",
			openIn: "Open in",
			sameWindow: "Open in same window",
			newWindow: "Open in new window",
			brandChangeTitle: "Brand change",
			brandChangeMessage: "When changing the brand, all internal links will be removed. Are you sure you want to continue?",
			teaserImage: "Teaser image",
			teaserImageTooltip: "Select an image to be displayed with this link. The image will be shown in the list view.",
			teaserImageDescription: "Select or upload an image",
			linkedArticlesArticleTypeLabel: "Only articles of type",
			linkedArticlesArticleTypeDownload: "Download articles",
			linkedArticlesArticleTypeChangeTitle: "Article type change",
			linkedArticlesArticleTypeChangeMessage: "All currently linked articles and links will be removed when the article type filter is changed. Are you sure you want to continue?"
		}
	},
	de: {
		articlesBoxApi: {
			createAlreadyExists: "Die Interne Linkbox kann nicht erstellt werden, da bereits eine andere Interne Linkbox mit diesem Namen existiert.",
			updateAlreadyExists: "Die Interne Linkbox kann nicht aktualisiert werden, weil bereits eine andere Interne Linkbox mit diesem Namen existiert.",
			created: "Interne Linkbox erstellt",
			updated: "Interne Linkbox aktualisiert",
			notFound: "Interne Linkbox nicht gefunden",
			requiredFields: "Die Interne Linkbox kann nicht gespeichert werden, weil Pflichtangaben fehlen."
		},
		articlesBoxList: {
			newButton: "Neue Interne Linkbox",
			search: "Suchen nach Titel, Beschreibung oder ID",
			deleteArticlesBox: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Interne Linkbox wird geladen",
			description: "Beschreibung (intern)",
			title: "Titel",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createArticlesBox: "Interne Linkbox erstellen",
			articleLinksCount: "Anzahl Artikel"
		},
		articlesBox: {
			selectorPlaceholder: "Interne Linkliste auswählen",
			showImagesCheckboxLabel: "Als Liste mit Bildern anzeigen",
			editBox: "Liste bearbeiten",
			articlesBoxLabel: "Interne Linkbox",
			newArticlesBox: "Neue Interne Linkbox",
			messageDeleteArticlesBox: "Interne Linkbox löschen",
			messageDeleteArticlesBoxTitle: "Willst du diese Interne Linkbox wirklich löschen?",
			deleteArticlesBox: "Löschen",
			messageDeleted: "Interne Linkbox gelöscht",
			errorOnDeleting: "Fehler beim Löschen der Internen Linkbox",
			errorFailedLoadedArticlesBoxWithId: "Fehler beim Abrufen der Internen Linkbox",
			description: "Beschreibung (intern)",
			contentBlockLabel: "Interne Linkbox"
		},
		articlesBoxEdit: {
			title: "Titel",
			description: "Beschreibung (intern)",
			editArticlesBox: "Interne linkbox bearbeiten",
			messageSaved: "Neue Interne Linkbox gespeichert",
			linkArticlesButton: "Artikel verlinken",
			addLinkButton: "Link hinzufügen",
			addLink: "Link hinzufügen",
			linkTitle: "Link-Titel",
			linkUrl: "Link-URL",
			openIn: "Öffnen in",
			sameWindow: "Im gleichen Fenster öffnen",
			newWindow: "In neuem Fenster öffnen",
			brandChangeTitle: "Markenwechsel",
			brandChangeMessage: "Wenn die Marke geändert wird, werden alle zugehörigen Links entfernt. Willst du wirklich fortfahren?",
			teaserImage: "Teaser-Bild",
			teaserImageTooltip: "Ein Bild für diesen Link auswählen. Es wird in der Listen-Ansicht angezeigt.",
			teaserImageDescription: "Bild auswählen oder hochladen",
			linkedArticlesArticleTypeLabel: "Nur Artikel vom Typ",
			linkedArticlesArticleTypeDownload: "Download-Artikel",
			linkedArticlesArticleTypeChangeTitle: "Artikeltyp ändern",
			linkedArticlesArticleTypeChangeMessage: "Alle aktuell verknüpften Artikel und Links werden entfernt, wenn der Artikeltyp-Filter geändert wird. Willst du wirklich fortfahren?"
		}
	}
}, r = [{
	path: "/articles-box",
	children: [
		{
			path: "",
			name: "articles_box_list",
			component: () => import("./articles-box-list.view-C8jm0TOB.js").then((e) => e.n),
			meta: { requiredRight: "articles-boxes:navigate" }
		},
		{
			path: "new",
			name: "articles_box_new",
			component: () => import("./articles-box-edit.view-Dvz57wqU.js").then((e) => e.n),
			props: () => ({
				title: t().t("articlesBox.newArticlesBox"),
				backRoute: "/articles-box"
			}),
			meta: { requiredRight: ["articles-boxes:navigate"] }
		},
		{
			path: ":id",
			name: "articles_box_detail",
			component: () => import("./articles-box-edit.view-Dvz57wqU.js").then((e) => e.n),
			props: (e) => ({
				title: t().t("articlesBoxEdit.editArticlesBox"),
				id: e.params.id,
				backRoute: "/articles-box"
			}),
			meta: { requiredRight: ["articles-boxes:navigate"] }
		}
	]
}], i = e(() => import("./articles-box-content-block-AdGgll3L.js")), a = {
	messages: n,
	routes: r,
	contentBlocks: [{
		type: "ARTICLES_BOX",
		label: "articlesBox.contentBlockLabel",
		icon: "link",
		component: i,
		defaultValue: {
			type: "ARTICLES_BOX",
			showImages: !1
		}
	}]
};
//#endregion
export { i as ArticlesBoxContentBlock, a as articlesBoxModule };

//# sourceMappingURL=index.es.js.map